/*
 * RUNIC CUSTOMIZED
 */

import clsx from 'clsx'
import {FC} from 'react'
import {useAuth} from '../../../../app/modules/auth'
import {HeaderUserMenu} from '../../../partials'
import {useLayout} from '../../core'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'

const Topbar: FC = () => {
  const {currentUser, logout, auth} = useAuth()
  const isImpersonation = currentUser?.isImpersonating
  const {config} = useLayout()
  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {/* begin::User */}
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        {/* begin::Toggle */}
        <div
          className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          {isImpersonation ? (
            <>
              <div
                className='fmenu-link px-1 fs-2 fas fa-exclamation-circle text-warning'
                style={{position: 'relative', top: '2px'}}
              ></div>{' '}
              Admin assisting: {currentUser?.email}
            </>
          ) : (
            <>Logged in as: {currentUser?.email}</>
          )}
        </div>
        <HeaderUserMenu />
        {/* end::Toggle */}
      </div>
      {/* end::User */}
    </div>
  )
}

export {Topbar}
